<template>
  <div class="card text-center">
    <img :src="icon ? require(`@/assets/icons/${icon}`) : ''"class="card-img-top" :alt="altText">
    <div class="card-body ">
      <h4 class="card-title">{{title}}</h4>
      <p class="card-text ws-16">{{text}}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ValueCard',
  props: {
    title: {
      type: String,
      default: 'Card title'
    },
    text: {
      type: String,
      default: 'card description'
    },
    icon: {
      type: String,
      default: 'cuidado.png'
    },
    altText: {
      type: String,
      default: '',
    }
  }
}
</script>